import { riskLevels } from '../../constants/riskLevels';
import clsx from 'clsx';

const getBackgroundColor = (color: string, isActive: boolean) => {
  if (!isActive) return 'bg-white';
  
  switch (color) {
    case 'bg-red-500':
      return 'bg-red-50';
    case 'bg-orange-500':
      return 'bg-orange-50';
    case 'bg-yellow-500':
      return 'bg-yellow-50';
    case 'bg-blue-500':
      return 'bg-blue-50';
    default:
      return 'bg-white';
  }
};

export default function RiskLevel() {
  return (
    <div>
      <h3 className="text-base font-semibold leading-6 text-gray-900 mb-4">
        Current Risk Level Status
      </h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {riskLevels.map((risk) => {
          const isActive = risk.status === 'active';
          const backgroundColor = getBackgroundColor(risk.color, isActive);
          
          return (
            <div
              key={risk.level}
              className={clsx(
                'relative rounded-lg p-6 transition-all duration-200',
                backgroundColor,
                isActive 
                  ? 'shadow-lg ring-2 ring-red-500 transform scale-105' 
                  : 'shadow'
              )}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <div className={clsx('h-4 w-4 rounded-full', risk.color)} />
                  <h4 className="ml-2 text-lg font-semibold text-gray-900">
                    {risk.name}
                  </h4>
                </div>
                <span className="text-sm font-medium text-gray-600">
                  Range: {risk.range}
                </span>
              </div>
              <p className="mt-2 text-sm text-gray-600">{risk.description}</p>
              {isActive && (
                <span className="absolute top-2 right-2 inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
                  Current Level
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}